<script setup lang="ts">
import DownloadPanel from '@/shared/components/DownloadPanel.vue'
</script>

<template>
  <!--
    统一 z-index 起点（默认 2000）。
    项目里各全屏遮罩（图片/视频预览、历史面板、下载面板）原本手写 3000~5000，
    与 Element Plus 的计数器互不相干，导致 toast / MessageBox 被遮罩盖住。
    这里保持默认计数器的同时，把项目内手写层级统一收敛到本层级之下（见各 CSS）。
  -->
  <el-config-provider :z-index="2000">
    <router-view />
    <DownloadPanel />
  </el-config-provider>
</template>
